import Axios from 'axios'
import config from 'src/config'

export type LuckyDrawWinner = {
  id: number
  dummyUsers: { agentCode: string }[]
  winner: string
  position: number
}

export type LuckyDrawResponse = {
  success: boolean
  winners_data: LuckyDrawWinner[]
}

export const fetchLuckyDrawWinners = (): Promise<LuckyDrawResponse> => {
  return Axios({
    method: 'get',
    url: `${config.apiUrl}/api/lucky_draws`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
    },
  }).then(({ data }) => data)
}
